'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { CONSENT_CHANGE_EVENT, readConsentSnapshot } from '@/lib/consent';

const FACEBOOK_PIXEL_ID = '1139189918338722';

function loadFacebookPixel() {
    if (window.fbq?.loaded) {
        window.fbq('consent', 'grant');
        return false;
    }

    const fbq = function (...args) {
        if (fbq.callMethod) fbq.callMethod(...args);
        else fbq.queue.push(args);
    };

    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.id = 'facebook-pixel-script';
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    fbq('consent', 'grant');
    fbq('init', FACEBOOK_PIXEL_ID);
    fbq('track', 'PageView');
    return true;
}

export function FacebookPixel() {
    const pathname = usePathname();
    const lastTrackedPathRef = useRef(null);
    const advertisingAllowedRef = useRef(false);

    useEffect(() => {
        function applyConsent(snapshot = readConsentSnapshot()) {
            const wasAllowed = advertisingAllowedRef.current;
            advertisingAllowedRef.current = snapshot.advertising === true;

            if (!snapshot.advertising) {
                window.fbq?.('consent', 'revoke');
                return;
            }

            const loadedNow = loadFacebookPixel();
            const consentWasJustGranted = !wasAllowed;
            const routeChanged = lastTrackedPathRef.current !== pathname;

            if (!loadedNow && (consentWasJustGranted || routeChanged)) {
                window.fbq('track', 'PageView');
            }

            lastTrackedPathRef.current = pathname;
        }

        function handleConsentChange(event) {
            applyConsent(event.detail);
        }

        applyConsent();
        window.addEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
        return () => window.removeEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
    }, [pathname]);

    return null;
}
